module.exports = __webpack_public_path__ + "static/media/hospital4.b745801b.webp";